/**
 * supernovaFlags — the two Supernova feature gates. BOTH DEFAULT OFF.
 *
 *   SUPERNOVA_TAB_ENABLED — the tab itself. Off ⇒ the app behaves exactly as it
 *                           does today: no tab, no chain reads, no network
 *                           traffic of any kind from this feature.
 *   SUPERNOVA_BUY_ENABLED — the "acquire an NFT" seam. Off ⇒ no purchase or
 *                           marketplace surface is reachable.
 *
 * Deliberately env-only and synchronous: these are build/preview switches, NOT
 * entitlements. Stake state is on-chain and belongs to the member's wallet — it
 * is never derived from, or coupled to, a Firebase membership record.
 *
 * Local preview (never set in production builds):
 *   REACT_APP_SUPERNOVA_TAB_ENABLED=true npm start
 *   REACT_APP_SUPERNOVA_BUY_ENABLED=true npm start
 *
 * Read through the functions rather than the constants where the value may be
 * flipped at runtime in a test; the constants are the convenient module-load
 * snapshot for render-time checks.
 */

const isOn = (value) => value === "true";

export function isSupernovaTabEnabled() {
  return isOn(process.env.REACT_APP_SUPERNOVA_TAB_ENABLED);
}

export function isSupernovaBuyEnabled() {
  return isOn(process.env.REACT_APP_SUPERNOVA_BUY_ENABLED);
}

export const SUPERNOVA_TAB_ENABLED = isSupernovaTabEnabled();
export const SUPERNOVA_BUY_ENABLED = isSupernovaBuyEnabled();
